module.exports = __webpack_public_path__ + "assets/retina_TorricelliPtDetailed.437e79acf2b7ade1b3a688a9c6e62ee7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/levels/2x/retina_TorricelliPtDetailed.png
// module id = 739
// module chunks = 0